import {
  IGeometryModel,
  MarkerModelBase,
} from '@types-custom/models/business/marker.model';

export interface IPropsAgentsModel {
  id: string;
  name: string;
  updatedDate: string;
  agentType: string;
  title: string;
  markerPopupText: string;
  icon: unknown;
}

export class AgentsModel extends MarkerModelBase {
  static className = 'AgentsModel';
  classProperties: IPropsAgentsModel;

  constructor(props: IPropsAgentsModel, geometry: IGeometryModel) {
    super(geometry, AgentsModel.className);
    this.classProperties = props;
  }
}
